<script setup lang="ts">

import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import PageHeader from "@/components/PageHeader.vue";
import UserHollandCodesDataTable from "@/pages/Insights/ReportsDetailPage/components/UserHollandCodesDataTable.vue";
import BaseResultsReport from "@/pages/Insights/ReportsDetailPage/components/BaseResultsReport.vue";
import { computed } from "vue";
import {useReportingStore} from "@/store/reporting";

const reportingState = useReportingStore();
reportingState.resetState();
reportingState.setAvailableFilters({
  tenants: true,
  institutions: true,
  cohorts: true,
  curriculum: false
});

const breadcrumbItems = computed(() => [
  { text: "Insights", to: { name: "reports" } },
  { text: "User Worker Types", to: null }
]);

</script>

<template>
  <authenticated-layout :back-route="{ name: 'reports' }" :breadcrumbs="breadcrumbItems">

    <page-header
      title="User Worker Types"
      description="Explore user worker type results"
    />
    <BaseResultsReport
      data-endpoint="user-worker-type-results"
      metric-endpoint="users-completed-holland-code-ratio">
      <template #report-table="{ tableData }">
        <user-holland-codes-data-table
          :loading-data="false"
          :report-data="tableData"
          class="borderless"
        />
      </template>
    </BaseResultsReport>
  </authenticated-layout>
</template>

<style scoped>

</style>
